import type { Chart } from "chart.js";

const defaultFont = { size: 14, style: "normal", family: "Helvetica Neue" };

export default function drawAliasOrNameLabel(chart: Chart, font: Partial<typeof defaultFont> = {}): void {
  const ctx = chart.ctx;
  const chartArea = chart.chartArea;
  const selectedFont = { ...defaultFont, ...font };

  chart.data.datasets.forEach((dataset, datasetIndex) => {
    const meta = chart.getDatasetMeta(datasetIndex);
    if (!chart.isDatasetVisible(datasetIndex)) {
      return;
    }

    let maxWidth = -1;

    meta.data.forEach((_element, index) => {
      const point = (dataset.data[index] as { metadata?: Record<string, unknown> } | undefined) ?? {};
      const metadata = point.metadata ?? {};
      const aliasHorizontal = metadata.aliasOrNameHorizontal as string | undefined;
      const aliasVertical = metadata.aliasOrNameVertical as string | undefined;
      const label = aliasHorizontal ?? aliasVertical;

      if (label) {
        const width = ctx.measureText(label).width;
        maxWidth = Math.max(maxWidth, width);
      }
    });

    meta.data.forEach((element, index) => {
      const point = (dataset.data[index] as { metadata?: Record<string, unknown> } | undefined) ?? {};
      const metadata = point.metadata ?? {};
      const aliasHorizontal = metadata.aliasOrNameHorizontal as string | undefined;
      const aliasVertical = metadata.aliasOrNameVertical as string | undefined;
      const horizontal = Boolean(aliasHorizontal);
      const label = aliasHorizontal ?? aliasVertical;

      if (!label) {
        return;
      }

      ctx.fillStyle = String((dataset as { borderColor?: string }).borderColor ?? "#000");
      ctx.font = `${selectedFont.style} ${selectedFont.size}px ${selectedFont.family}`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      const x = (element as { x: number }).x;
      const y = (element as { y: number }).y;
      const padding = 4;
      const offset = 2;
      const height = selectedFont.size + padding + offset;
      const width = horizontal ? ctx.measureText(label).width : maxWidth;
      const widthP = width + offset + padding;

      if (horizontal) {
        const targetY = y - height;
        if (
          chartArea.top < targetY + height + padding &&
          chartArea.bottom >= targetY + height &&
          chartArea.left < x + padding &&
          chartArea.right > x - 2 * padding
        ) {
          let offsetY = 0;
          if (chartArea.top > targetY - selectedFont.size + padding) {
            offsetY = height * 2;
          }

          ctx.fillRect(
            x - width / 2 - padding,
            targetY - selectedFont.size / 2 - padding + offsetY,
            width + 2 * padding,
            selectedFont.size + 2 * padding
          );
          ctx.fillStyle = "#ffffff";
          ctx.fillText(label, x, targetY + offsetY);
        }
      } else {
        const targetX = x - widthP;
        if (
          chartArea.top < y + selectedFont.size &&
          chartArea.bottom > y - selectedFont.size &&
          chartArea.left <= targetX + widthP &&
          chartArea.right > targetX
        ) {
          let offsetX = 0;
          if (chartArea.left >= targetX - width + padding) {
            offsetX = widthP * 2;
          }

          ctx.fillRect(
            targetX - width / 2 - padding + offsetX,
            y - selectedFont.size / 2 - padding,
            width + 2 * padding,
            selectedFont.size + 2 * padding
          );
          ctx.fillStyle = "#ffffff";
          ctx.fillText(label, targetX + offsetX, y);
        }
      }
    });
  });
}
